var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ParticipantShiftsTableHeader } from '../../../../../ui/features/shift-details/components/participant-details-tables/ParticipantShiftsTableHeader';
import { useParticipantPastShiftsTableDataProvider } from '../../../../../ui/features/shift-details/hooks/useParticipantPastShiftsTableDataProvider';
import { useParticipantShiftsTableActions } from '../../../../../ui/features/shift-details/hooks/useParticipantShiftsTableActions';
import { useParticipantShiftsTableColumns } from '../../../../../ui/features/shift-details/hooks/useParticipantShiftsTableColumns';
import { useSelectActionsParticipantShiftsTable } from '../../../../../ui/features/shift-details/hooks/useSelectActionsParticipantShiftsTable';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { DataTable, TablePaginationContent, useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { Box } from '@mui/material';
import React from 'react';
export const ParticipantShiftsTable = ({ row, defaultRowsPerPage, missionId, onSendMessageToVolunteers, fetchAnalytics, onRowClick, }) => {
    const { dataTableProps } = useDataTableUsingState({
        useDataProvider: (request) => useParticipantPastShiftsTableDataProvider(request, {
            participantId: row.participantId,
            missionId: missionId,
        }),
        defaultSortColumnKey: '',
        defaultRowsPerPage,
        rowSelectionEnabled: true,
    });
    const { rows: shifts, filteredRowCount: totalShifts, customBackendResponseData } = dataTableProps;
    const fetchReload = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        yield ((_a = customBackendResponseData === null || customBackendResponseData === void 0 ? void 0 : customBackendResponseData.mutate) === null || _a === void 0 ? void 0 : _a.call(customBackendResponseData).then(() => {
            fetchAnalytics();
        }));
    });
    const { handleSelectAll, handleSingleSelect, selected } = useSelectActionsParticipantShiftsTable(dataTableProps === null || dataTableProps === void 0 ? void 0 : dataTableProps.customBackendResponseData);
    const columns = useParticipantShiftsTableColumns({
        fetchReload,
    });
    const globalActions = useParticipantShiftsTableActions({
        shifts,
        onSendMessageToVolunteers,
        selected,
        fetchReload,
        missionId,
        participantId: row.participantId,
        participantFullName: row.participantFullName,
    });
    if (!shifts) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(DataTable, Object.assign({}, dataTableProps, { columns: columns, hideHeader: true, title: React.createElement(ParticipantShiftsTableTitle, null), headerSx: {
            borderTop: `1px solid ${themeColors.border.main}`,
            borderBottom: `1px solid ${themeColors.border.main}`,
            py: 2,
            px: 1,
            mb: 0,
            pl: 4,
            position: 'relative',
        }, onRowClick: onRowClick, selectedRowIds: selected, onRowSelectionChange: handleSingleSelect, customTableSurfaceComponent: ({ children }) => React.createElement(Box, null, children), customHeaderElement: React.createElement(ParticipantShiftsTableHeader, { onClick: handleSelectAll, selectedShifts: selected, totalShifts: totalShifts }), globalActions: globalActions, customTablePaginationContentComponent: (props) => (React.createElement(Box, { sx: { mt: 2 } },
            React.createElement(TablePaginationContent, Object.assign({}, props)))) })));
};
const ParticipantShiftsTableTitle = () => {
    const { t } = useMissionsTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(FlagOutlinedIcon, { sx: { position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)' } }),
        React.createElement(Box, { sx: { display: 'inline', position: 'relative' } }, t('shifts.shiftsByVolunteerTable.shifts'))));
};
